import api from './apiClient';

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const basePath = `${BASE_URL}/api/v1/dictionary`;

export default {
  getMedicines() {
    return api.get(`${basePath}/medicines`).then((res: any) => res.data);
  },
  getUnits() {
    return api.get(`${basePath}/units`).then((res: any) => res.data);
  },
  getCarBrands() {
    return api.get(`${basePath}/car-brands`).then((res: any) => res.data);
  },
  getFuelTypes() {
    return api.get(`${basePath}/fuel-types`).then((res: any) => res.data);
  },
  getItProducts() {
    return api.get(`${basePath}/it-products`).then((res: any) => res.data);
  },
  getItProductItems() {
    return api.get(`${basePath}/it-product-items`).then((res: any) => res.data);
  },
  getMaterialGroups() {
    return api.get(`${basePath}/material-groups`).then((res: any) => res.data);
  },
  getMaterialTypes() {
    return api.get(`${basePath}/material-types`).then((res: any) => res.data);
  },
  getMaterialProducts() {
    return api.get(`${basePath}/material-products`).then((res: any) => res.data);
  },
  searchMaterialProducts(query: string, limit: number = 50, category?: string) {
    const params: any = { query, limit };
    if (category) params.category = category;
    return api.get(`${basePath}/material-products/search`, { params }).then((res: any) => res.data);
  },
  getMaterialCategories() {
    return api.get(`${basePath}/material-categories`).then((res: any) => res.data);
  },
  getMeasureUnits() {
    return api.get(`${basePath}/measure-units`).then((res: any) => res.data);
  },
  getStudentExpenseTypes() {
    return api.get(`${basePath}/student-expense-types`).then((res: any) => res.data);
  },
  getStaffCategories() {
    return api.get(`${basePath}/staff-categories`).then((res: any) => res.data);
  }
};
